export default {
  SET_CURRENT_LOG(state, data) {
    state.currentLog = data.content
  },
  CLEAR_CURRENT_LOG(state) {
    state.currentLog = null
  },
  SET_LOGS_UNSOLVED_COUNT(state, data) {
    state.unsolved = data
  },
}
